
    var riot = require('riot')
    riot.tag2('contact-modal-error', '<div name="modalBackground" class="modal-background-without-transition modal-default" data-modal-background data-modal-close-trigger riot-style="z-index: 10000; height: {modalHeight}px" data-clickable-list-ignore-click onclick="{onClose}" if="{showModal}"> <div name="modal" class="modal" data-modal> <button class="modal-close" onclick="{onClose}"></button> <div class="messaging-modal-body"> <div class="messaging-modal-body-icon"> <span class="warning--before {isError ? \'red\' : \'yellow\'}"></span> </div> <h2 class="messaging-modal-text text-center" show="{header}">{header}</h2> <p class="messaging-modal-text text-center">{message}</p> <button class="secondary-action messaging-modal-message-action" onclick="{onRetry}" show="{retryButtonVisible}">{retryButtonText}</button> <button class="{retryButtonVisible ? \'default-action messaging-modal-message-action\' : \'secondary-action\'}" onclick="{onAbort}">{abortButtonText}</button> </div> </div> </div>', '', '', function(opts) {
        var modalMixin = require('static/script/app/ui/mixin/modal-mixin');
        this.mixin(modalMixin);

        this.isError = true;
        this.validationError = 'ValidationError';
        this.fatalError = 'Fatal';
        this.sendError = 'Unable to send message';
        this.newHighestBidderError = 'New highest bidder';
        this.defaultMessage = 'Ett fel har uppstått.';
        this.retryButtonText = 'Ja';
        this.retryButtonVisible = true;
        this.abortButtonText = 'Nej';
        this.message = this.defaultMessage;
        this.header = null;
        this.payload = null;

        this.init = function(payload) {

            this.payload = null;
            this.header = null;
            this.isError = true;

            this.errors = payload.errors;
            if (payload.errorType === this.validationError) {
                this.message = payload.message;
                if (this.message.length === 0) {
                    this.message = payload.errors.join(' ');
                };
                this.retryButtonText = 'Försök igen';
                this.abortButtonText = 'Avbryt';
            }

            if (payload.errorType === this.newHighestBidderError) {
                this.payload = payload.newBidder;
                this.header = 'Ny högste budgivare!';
                this.message = payload.newBidder.alias + ' är nu högste budgivare. Vill du gå tillbaka till meddelandet och skicka det till den nya högste budgivaren?';
                this.isError = false;
                this.retryButtonText = 'Ja';
                this.abortButtonText = 'Avbryt';
            }

            if (payload.errorType === this.fatalError) {
                this.message = this.defaultMessage;
                this.retryButtonVisible = false;
                this.abortButtonText = 'Stäng';
            }

            if (payload.errorType === this.sendError) {
                this.message = this.defaultMessage;
                this.retryButtonVisible = false;
                this.abortButtonText = 'Stäng';
            }
        }.bind(this);

        this.onAbort = function() {
            this.bus.trigger('ui:contact-modal:on-abort');
        }.bind(this);

        this.onRetry = function() {
            this.bus.trigger('ui:contact-modal:on-retry', this.payload);
        }.bind(this);

        this.onMessageSent_failed = function(payload) {
            this.init(payload.response.responseJSON);
            this.show();
        }.bind(this);

        this.on('mount', function () {
            this.bus.on('ui:contact-modal:on-retry', this.hide);
            this.bus.on('data:contact-service:message-sent-failed', this.onMessageSent_failed);
            this.bus.on('ui:contact-modal:on-close', this.close);
        });

});

    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-error.riot.html